import axios from 'axios'
import store from '@/store'
import router from '@/router'

// 创建axios实例
const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://geekid.com.cn/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 添加认证token
    const token = store.getters['auth/token']
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.response) {
      const { status, data } = error.response
      
      // 处理认证失败
      if (status === 401) {
        store.dispatch('auth/logout')
        router.push('/login')
        return Promise.reject(new Error('登录已过期，请重新登录'))
      }
      
      // 处理其他错误
      const message = data?.message || '请求失败'
      return Promise.reject(new Error(message))
    }
    
    return Promise.reject(error)
  }
)

// 认证相关API
export const authAPI = {
  // 管理员登录
  adminLogin: (credentials) => api.post('/auth/admin/login', credentials),

  // 代理商登录
  agentLogin: (credentials) => api.post('/auth/agent/login', credentials),

  // 获取当前用户信息
  getCurrentUser: () => api.get('/auth/me'),

  // 获取个人资料
  getProfile: () => api.get('/auth/profile'),

  // 更新个人资料
  updateProfile: (data) => api.put('/auth/profile', data),

  // 修改密码
  changePassword: (data) => api.post('/auth/change-password', data),

  // 退出登录
  logout: () => api.post('/auth/logout')
}

// 卡密管理API
export const cardAPI = {
  // 获取卡密列表
  getCards: (params) => api.get('/cards', { params }),
  
  // 生成卡密
  generateCards: (data) => api.post('/cards/generate', data),
  
  // 编辑卡密信息
  updateCard: (id, data) => api.put(`/cards/${id}`, data),

  // 更新卡密状态
  updateCardStatus: (id, data) => api.put(`/cards/${id}/status`, data),

  // 删除卡密
  deleteCard: (id) => api.delete(`/cards/${id}`),
  
  // 获取卡密统计
  getCardStats: () => api.get('/cards/stats')
}

// 用户管理API
export const userAPI = {
  // 获取用户列表
  getUsers: (params) => api.get('/users', { params }),

  // 获取在线用户
  getOnlineUsers: () => api.get('/users/online'),

  // 获取用户统计
  getUserStats: () => api.get('/users/stats'),

  // 获取用户详情
  getUserDetail: (id) => api.get(`/users/${id}`),

  // 更新用户状态
  updateUserStatus: (id, data) => api.put(`/users/${id}/status`, data),

  // 踢出用户
  kickUser: (id) => api.post(`/users/${id}/kick`)
}

// 日志管理API
export const logAPI = {
  // 获取验证日志
  getVerifyLogs: (params) => api.get('/logs/verify', { params }),

  // 获取操作日志
  getOperationLogs: (params) => api.get('/logs/operation', { params }),

  // 获取在线用户
  getOnlineUsers: (params) => api.get('/logs/online-users', { params }),

  // 获取验证统计
  getVerifyStats: (params) => api.get('/logs/verify-stats', { params }),

  // 获取系统状态
  getSystemStatus: (params) => api.get('/logs/system-status', { params })
}

// 配置管理API
export const configAPI = {
  // 获取系统配置
  getConfigs: () => api.get('/config'),

  // 更新单个配置
  updateConfig: (key, data) => api.put(`/config/${key}`, data),

  // 批量更新配置
  updateConfigs: (data) => api.put('/config', data),

  // 获取权限配置
  getPermissions: () => api.get('/config/permissions'),

  // 更新权限配置
  updatePermission: (cardType, permissionKey, data) =>
    api.put(`/config/permissions/${cardType}/${permissionKey}`, data),

  // 获取系统信息
  getSystemInfo: () => api.get('/config/system-info')
}

// 代理商管理API
export const agentAPI = {
  // 获取代理商列表
  getAgents: (params) => api.get('/agents', { params }),
  
  // 创建代理商
  createAgent: (data) => api.post('/agents', data),
  
  // 更新代理商信息
  updateAgent: (id, data) => api.put(`/agents/${id}`, data),
  
  // 更新代理商状态
  updateAgentStatus: (id, data) => api.put(`/agents/${id}/status`, data),
  
  // 重置代理商密码
  resetAgentPassword: (id, data) => api.put(`/agents/${id}/password`, data),
  
  // 获取代理商统计
  getAgentStats: () => api.get('/agents/stats')
}



export default api
